import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const YarnInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Yarn Section"
    sectionKey="Yarn"
    backRoute="/sections/yarn"
  />
);

export default YarnInternalTransfer;
